'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = require('../constants');

var _constants2 = require('@arreeba/ristoranti-lib/lib/constants');

var initialState = {
  userLocation: null,
  isFetching: false,
  availability: [],
  date: null,
  hasBookingRushes: false, // optimistic bookingrush flag
  verifiedBookingRush: false,
  time: null,
  seats: null,
  pickerVisible: false,
  pickerType: _constants.BOOKING_PICKER_TIME,
  formData: null,
  createdRequest: {
    id: null,
    status: null
  },
  targetRestaurant: null
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _constants.SET_USER_LOCATION:
      return _extends({}, state, {
        userLocation: action.location
      });

    case _constants2.LOAD_BOOKING_AVAILABILITY_START:
      return _extends({}, state, {
        isFetching: true
      });

    case _constants2.LOAD_BOOKING_AVAILABILITY_SUCCESS:
      return _extends({}, state, {
        isFetching: false,
        availability: action.data.merchant.restaurants
      });

    case _constants2.LOAD_BOOKING_AVAILABILITY_FAILURE:
      return _extends({}, state, {
        isFetching: false,
        availability: []
      });

    case _constants.SET_BOOKING_RESTAURANT:
      return _extends({}, state, {
        targetRestaurant: action.restaurant
      });

    case _constants.SET_BOOKING_DATE:
      return _extends({}, state, {
        date: action.date,
        hasBookingRushes: action.hasBookingRushes
      });

    case _constants.SET_PICKER_VISIBILITY:
      return _extends({}, state, {
        pickerVisible: action.value,
        pickerType: action.pickerType || _constants.BOOKING_PICKER_TIME
      });

    case _constants.SET_BOOKING_TIME:
      return _extends({}, state, {
        time: action.time,
        verifiedBookingRush: action.verifyBookingRush,
        seats: null // reset seats when user change booking time
      });

    case _constants.SET_BOOKING_SEATS:
      return _extends({}, state, {
        seats: action.n
      });

    case _constants.BOOKING_SET_FORM:
      return _extends({}, state, {
        formData: action.data
      });

    case _constants2.BOOKING_REQUEST_CREATE_START:
      return _extends({}, state, {
        isFetching: true
      });

    case _constants2.BOOKING_REQUEST_CREATE_SUCCESS:
      return _extends({}, initialState, {
        createdRequest: {
          hasBookingRushes: state.verifiedBookingRush,
          id: action.data.id,
          date: action.data.date,
          availabilitySlot: action.data.availabilitySlot,
          status: action.data.status
        }
      });

    case _constants2.BOOKING_REQUEST_CREATE_FAILURE:
      return _extends({}, state, {
        isFetching: false
      });

    case _constants.BOOKING_RESET_END:
      return _extends({}, initialState);

    /* partial reset state to avoid inconsistency */
    case _constants.UPDATE_ROUTE:
      {
        if (action.route === 'booking-select-date') {
          return _extends({}, state, {
            date: null,
            verifiedBookingRush: false,
            pickerVisible: false,
            pickerType: initialState.pickerType,
            time: null,
            seats: null
          });
        }

        return state;
      }

    case _constants2.SWITCH_BUNDLE_ID:
      return _extends({}, initialState);

    default:
      return state;
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-frontend-lib/lib/reducers/booking.js
// module id = 196
// module chunks = 0